<template>
  <div class="TodayStatistics">
    <div class="search">
      <div class="search_box">
        <div class="search_options_box">
          <span style="width: auto;white-space: nowrap">综合搜索</span>
          <el-input v-model="ImeiSearch" style="width: calc(100% - 72px);" placeholder="请输入设备IMEI码" ></el-input>
        </div>
        <div class="search_options_box">
          <span style="width: auto;white-space: nowrap">设备类型</span>
          <el-select class="select" v-model="selectValue" placeholder="请选择设备类型" >
            <el-option v-for="item in search[0].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </div>
        <div class="search_btn_box">
          <button :class='["search_btn","green","icon_btn","clearborder"]'><span class="el-icon-search"></span>搜索</button>
        </div>
      </div>
      <div class="search_information">
        <div class="search_information_content">
          <div style="background-color: #16518d">
            <span><img src="/static/img/control.svg" width="40" height="36"></span>
          </div>
          <div>
            <p style="color: #00FFF6">控制器</p>
            <span style="color: #00FFF6">{{this.statistics.controller.total_count+this.statistics.smart_controller.total_count}}</span>
          </div>
        </div>
        <div class="search_information_content">
          <div style="background-color: #16518d">
            <span><img src="/static/img/lamppost.svg" width="40" height="36"></span>
          </div>
          <div>
            <p style="color: #33F08F">灯杆</p>
            <span style="color: #33F08F">{{this.statistics.lamppost}}</span>
          </div>
        </div>
        <div class="search_information_content">
          <div style="background-color: #16518d">
            <span><img src="/static/img/breakdown.svg" width="40" height="36"></span>
          </div>
          <div>
            <p style="color: #F32061">故障</p>
            <span style="color: #F32061">{{this.statistics.controller.fault_count+this.statistics.smart_controller.fault_count}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="operation">
      <div>
        <span>控制模式：</span>
        <button :class='["operation_btn","blue","icon_btn","clearborder"]' @click="ArtificialControl()">手动控制</button>
        <button :class='["operation_btn","yellow","icon_btn","clearborder"]' @click="AutomateControl()">自动控制</button>
      </div>
      <div>
        <span >集控器控制：</span>
        <!--        <img src="/static/img/select.png" alt="">-->
        <!--        <select v-model="Passageway">-->
        <!--          <option :value="item.value" v-for="item in PassagewayData">{{item.name}}</option>-->
        <!--        </select>-->
        <button :class='["operation_btn","green","icon_btn","clearborder"]' @click="OpenPassageway()" >开启所有通道</button>
        <button :class='["operation_btn","green","icon_btn","clearborder"]' @click="ClosePassageway()" >关闭所有通道</button>
        <button :class='["operation_btn","green","icon_btn","clearborder"]' @click="CorrectionTime()" >校准时间</button>
        <button :class='["operation_btn","green","icon_btn","clearborder"]' @click="OperationalControl()" >设置集控器控制时间
        </button>
        <span>单灯控制：</span>
        <button :class='["operation_btn","green","icon_btn","clearborder"]' @click="OpenLamp()">开灯</button>
        <button :class='["operation_btn","green","icon_btn","clearborder"]' @click="CloseLamp">关灯</button>
        <button :class='["operation_btn","green","icon_btn","clearborder"]' @click="AdjustBrightness()">调节亮度</button>
        <button :class='["operation_btn","green","icon_btn","clearborder"]'  @click="OperationalLamp()">设置单灯控制时间</button>
      </div>
    </div>
    <div class="table_content">
      <table>
        <thead>
        <tr>
          <th width="60px"><input type="checkbox" class="control" @click='ControlCheckedAll()'></th>
          <th width="60px">序号</th>
          <th width="200px">设备信息</th>
          <th>设备位置</th>
          <th>设备状态</th>
          <th colspan="2">工作状态</th>
          <th>信号强度</th>
          <th>控制类型</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody v-for="(item,index) in currentPageData" :key="index">
        <tr>
          <td><input type="checkbox" name="control" class="control" @click='ControlCheckedOne(item.id)'></td>
          <td>{{index+1}}</td>
          <td class="toggle" style="position: relative;">
            <span
              style="width: 20px;height: 20px;position: absolute;top: 20px;left:0;cursor: pointer;background: url(/static/img/lamp/tableopen.png) no-repeat center center;"></span>
            <p style="text-align: left;padding-left: 30px;font-size: 20px;color: #00FFF0;" v-if="item.IMEI===''">{{item.name}}</p>
            <p style="text-align: left;padding-left: 20px;font-size: 14px;color: #00FFF0;" v-else>{{item.IMEI}}</p>
            <p style="text-align: left;font-size: 12px;display: block" v-if="item.IMEI!==''">校准返回时间:<span
              style="text-align: left;font-size: 12px;">2019-09-03T09:34:49</span></p>
            <p style="text-align: left;font-size: 12px;" v-if="item.IMEI!==''">更新控制时间:<span style="text-align: left;font-size: 12px;">{{item.create_datetime}}</span>
            </p>
          </td>
          <td>{{item.site}}</td>
          <td v-if="item.is_online==='0'">离线</td>
          <td v-else-if="item.is_online===''" style="text-align:center">--</td>
          <td v-else>在线</td>
          <td v-if="item.IMEI===''"  colspan="2">--</td>
          <td colspan="2" v-else>
            <img
              :src="item.work_state[0]=='1'?'/static/img/lamp/lampopen.png':'/static/img/lamp/lampclose.png'"
              alt="">
            <img
              :src="item.work_state[1]=='1'?'/static/img/lamp/lampopen.png':'/static/img/lamp/lampclose.png'"
              alt="">
            <img
              :src="item.work_state[2]=='1'?'/static/img/lamp/lampopen.png':'/static/img/lamp/lampclose.png'"
              alt="">
            <img
              :src="item.work_state[3]=='1'?'/static/img/lamp/lampopen.png':'/static/img/lamp/lampclose.png'"
              alt="">
          </td>
          <td v-if="item.IMEI===''" >--</td>
          <td v-else>
            <img
              :src="item.signal_strength.toString()==='0'?'/static/img/lamp/signalfull.png':'/static/img/lamp/signal.png'"
              alt="">
          </td>
          <td v-if="item.mode==='0'">自动模式</td>
          <td v-else-if="item.mode===''" style="text-align:center">--</td>
          <td v-else>手动模式</td>
          <td>--</td>
        </tr>
        <tr class="table-child table-child-title tablehide">
          <th><input type="checkbox" class="lamp" @click="LampCheckedAll($event,index,item.IMEI)"/></th>
          <th>序号</th>
          <th>单灯设备码</th>
          <th>所属通道</th>
          <th>设备位置</th>
          <th>设备类型</th>
          <th>设备状态</th>
          <th>亮灯状态</th>
          <th>控制类型</th>
          <th>亮度</th>
          <th>操作</th>
        </tr>
        <tr class="table-child tablehide" v-for="(item2,index) in item.children">
          <td><input type="checkbox" class="lamp" :name="item.IMEI+'lamp'" @click="LampCheckedOne(item2.lamppost.toString())"/>
          </td>
          <td>{{index+1}}</td>
          <td>{{item2.lamppost}}</td>
          <td v-if="item2.passageway==='1'">通道一</td>
          <td v-else-if="item2.passageway==='2'">通道二</td>
          <td v-else-if="item2.passageway==='3'">通道三</td>
          <td v-else-if="item.IMEI===''">--</td>
          <td v-else>通道四</td>
          <td>{{item2.site}}</td>
          <td v-if="item2.type==='1'">NB单灯控制器</td>
          <td v-if="item2.type==='2'">PLC单灯控制器</td>
          <td v-if="item2.type==='3'">其他单灯</td>
          <td v-if="item2.is_online">在线</td>
          <td v-else>离线</td>
          <td>
            <img
              :src="item2.status.toString()==='0'?'/static/img/lamp/singlelampclose.png':'/static/img/lamp/singlelampopen.png'"
              alt="">
          </td>
          <td v-if="item2.mode==='0'">自动模式</td>
          <td v-else>手动模式</td>
          <td v-if="item2.brightness==='1'">20%</td>
          <td v-if="item2.brightness==='2'">40%</td>
          <td v-if="item2.brightness==='3'">60%</td>
          <td v-if="item2.brightness==='4'">80%</td>
          <td v-if="item2.brightness==='5'">100%</td>
          <!--<td v-else>0%</td>-->
          <td class="table_btn_box">
            <button class="table_btn" @click="LampNewData(item2.lamppost)">最新数据</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="table_paging">
      <p>当前记录<span>1</span>到<span>9</span>条，共<span>45</span>条记录
        <button
          v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>
        <button
          @click="prevPage()"
          v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>
        第<span>{{currentPage}}</span>/<span>{{totalPage}}</span>页
        <button
          @click="nextPage()"
          v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>
        <button
          v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>
      </p>
    </div>


    <!--  集控器时间调节-->
    <transition name="fade">
      <div class="mark" v-if="OperationalControlBox">
        <div class="mark_close" @click="OperationalControlBox=!OperationalControlBox"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'700px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model">
            <h1>
              设置集控器控制时间
            </h1>
            <div style="padding: 0 60px;box-sizing: border-box">
              <div class="Period">
                <div class="block">
                  <span class="demonstration">第一阶段时间设置</span>
                  <el-time-picker
                    v-model="OperationalControlForm.time.PeriodStart_1"
                    is-range
                    arrow-control
                    value-format="HH:mm"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-time-picker>
                </div>
                <div class="block">
                  <span class="demonstration">第二阶段时间设置</span>
                  <el-time-picker
                    v-model="OperationalControlForm.time.PeriodStart_2"
                    is-range
                    arrow-control
                    value-format="HH:mm"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-time-picker>
                </div>
                <div class="block">
                  <span class="demonstration">第三阶段时间设置</span>
                  <el-time-picker
                    v-model="OperationalControlForm.time.PeriodStart_3"
                    is-range
                    arrow-control
                    value-format="HH:mm"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-time-picker>
                </div>
              </div>
              <div class="week">
                <span>选择星期：</span>
                <label><input id="ControlWeekAll" type="checkbox" value="0" @click="ControlWeekAll"/>全部</label>
                <label v-for="(item,index) in Week" :key="index"><input type="checkbox" :value="item.value"
                                                                        name="ControlWeek"
                                                                        v-model="OperationalControlForm.week"
                                                                        @click="ControlWeekOne(item.value)"/>{{item.week}}</label>
                <div style="clear: both"></div>
              </div>
              <div class="Passage">
                <span>选择通道：</span>
                <label><input id="ControlPassageAll" type="checkbox" value="0" @click="ControlPassageAll"/>全部</label>
                <label v-for="(item,index) in ControlPassage"><input type="checkbox" :value="item.value"
                                                                     name="ControlWeek"
                                                                     v-model="OperationalControlForm.Passage"
                                                                     @click="ControlPassageOne(item.value)"/>{{item.Passage}}</label>
              </div>
            </div>
            <div class="sbt_box">
              <button :class='["add_btn","delete","icon_btn","clearborder"]'
                      @click="OperationalControlBox = !OperationalControlBox">取消
              </button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="OperationalControlSbt()">提交</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!--  调节亮度-->
    <transition name="fade">
      <div class="mark" v-if="brightness">
        <div class="mark_close" @click="brightness=!brightness"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'500px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model">
            <h1>
              调节亮度
            </h1>
            <div style="padding: 0 60px;box-sizing: border-box">
              <el-slider v-model="brightnessData" :show-tooltip="false" :min="1" :max="5"></el-slider>
              <div class="scale">
                <span style="left: -10px">20%</span>
                <span style="left: 21%">40%</span>
                <span style="left: 46%">60%</span>
                <span style="left: 71%">80%</span>
                <span style="left: 94%">100%</span>
              </div>
            </div>
            <div class="sbt_box">
              <button :class='["add_btn","delete","icon_btn","clearborder"]' @click="brightness_cancel()">取消</button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="brightness_sbt()">提交</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!--  单灯时间调节-->
    <transition name="fade">
      <div class="mark" v-if="OperationalLampBox">
        <div class="mark_close" @click="OperationalLampBox=!OperationalLampBox"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'730px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model">
            <h1>
              设置单灯控制时间
            </h1>
            <div style="padding: 0 60px;box-sizing: border-box">
              <div class="Period">
                <div class="block">
                  <span class="demonstration">第一阶段时间设置</span>
                  <el-time-picker
                    v-model="OperationalLampForm.time.PeriodStart_1"
                    is-range
                    arrow-control
                    value-format="HH:mm"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-time-picker>
                  <el-select v-model="OperationalLampForm.brightness.brightness_1" placeholder="亮度" style="width: 90px">
                    <el-option
                      v-for="item in brightnessSelect"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="block">
                  <span class="demonstration">第二阶段时间设置</span>
                  <el-time-picker
                    v-model="OperationalLampForm.time.PeriodStart_2"
                    is-range
                    arrow-control
                    value-format="HH:mm"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-time-picker>
                  <el-select v-model="OperationalLampForm.brightness.brightness_2" placeholder="亮度" style="width: 90px">
                    <el-option
                      v-for="item in brightnessSelect"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="block">
                  <span class="demonstration">第三阶段时间设置</span>
                  <el-time-picker
                    v-model="OperationalLampForm.time.PeriodStart_3"
                    is-range
                    arrow-control
                    value-format="HH:mm"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-time-picker>
                  <el-select v-model="OperationalLampForm.brightness.brightness_3" placeholder="亮度" style="width: 90px">
                    <el-option
                      v-for="item in brightnessSelect"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="block">
                  <span class="demonstration">第四阶段时间设置</span>
                  <el-time-picker
                    v-model="OperationalLampForm.time.PeriodStart_4"
                    is-range
                    arrow-control
                    value-format="HH:mm"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-time-picker>
                  <el-select v-model="OperationalLampForm.brightness.brightness_4" placeholder="亮度" style="width: 90px">
                    <el-option
                      v-for="item in brightnessSelect"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="week">
                <span>选择星期：</span>
                <label><input id="LampWeekAll" type="checkbox" value="0" @click="LampWeekAll"/>全部</label>
                <label v-for="(item,index) in weekdays" :key="index"><input type="checkbox" :value="item.value"
                                                                            name="ControlWeek"
                                                                            v-model="OperationalLampForm.week"
                                                                            @click="LampWeekOne(item.value)"/>{{item.week}}</label>
                <div style="clear: both"></div>
              </div>
            </div>
            <div class="sbt_box">
              <button :class='["add_btn","delete","icon_btn","clearborder"]'
                      @click="OperationalLampBox = !OperationalLampBox">取消
              </button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="OperationalLampSbt()">提交</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!--    开灯-->
    <transition name="fade">
      <div class="mark" v-if="Open">
        <div class="mark_close" @click="Open=!Open"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'500px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model">
            <h1>
              开灯
            </h1>
            <div style="padding: 0 60px;box-sizing: border-box;font-size: 16px">
              <h1 class="tip">是否要开启所有已选择单灯</h1>
            </div>
            <div class="sbt_box">
              <button :class='["add_btn","delete","icon_btn","clearborder"]' @click="OpenLamp_cancel()">取消</button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="OpenLamp_sbt()">确定</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!--    关灯-->
    <transition name="fade">
      <div class="mark" v-if="Close">
        <div class="mark_close" @click="Close=!Close"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'500px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model">
            <h1>
              关灯
            </h1>
            <div style="padding: 0 60px;box-sizing: border-box;">
              <h1 class="tip">是否要关闭所有已选择单灯</h1>
            </div>
            <div class="sbt_box">
              <button :class='["add_btn","delete","icon_btn","clearborder"]' @click="CloseLamp_cancel()">取消</button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="CloseLamp_sbt()">确定</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade" v-on:leave="leave" class="msg-rbox">
      <div class="mark" v-if="msg_show" style="z-index: 99999">
        <div class="mark_close" @click="msg_show=!msg_show"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'500px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="information_content issue_search_box model">
            <div id="msg">{{message}}</div>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
  //引入echarts
  let echarts = require('echarts/lib/echarts')
  // 引入柱状图组件
  require('echarts/lib/chart/bar')
  require('echarts/lib/chart/line')
  require('echarts/lib/chart/pie')
  // 引入提示框和title组件
  require('echarts/lib/component/tooltip')
  require('echarts/lib/component/title');
  require('echarts/lib/component/legend');


  export default {
    name: "TodayStatistics",
    data() {
      return {
        search: [
          {
            options: [
              {label: "集控器",value:"1"},
              {label: "智控器",value:"2"},
              {label: "单灯",value:"3"},
            ]
          }
        ],
        selectValue:'',
        statistics: [],
        statistics_number: [
          {number: "4"},
          {number: "4"},
          {number: "1"},
          //{number: "60"},
        ],
        chart_circle: [
          {
            "name": "空闲占枪",
            "value": 10
          }, {
            "name": "维护",
            "value": 10
          }, {
            "name": "空闲",
            "value": 10
          }, {
            "name": "充电",
            "value": 10
          }, {
            "name": "故障",
            "value": 10
          }
        ],
        //弹窗
        ImeiSearch:'',
        refresh: false,
        fix_show: false,
        brightness: false,//亮度
        brightnessData: 0,
        brightnessSelect: [
          {value: '1', label: '20%'},
          {value: '2', label: '40%'},
          {value: '3', label: '60%'},
          {value: '4', label: '80%'},
          {value: '5', label: '100%'},
        ],
        msg_show: false,//消息弹窗
        message: "",//消息内容
        OperationalControlBox: false,
        OperationalLampBox: false,
        value6: '',

        Week: [
          {week: "星期一", value: "1"},
          {week: "星期二", value: "2"},
          {week: "星期三", value: "4"},
          {week: "星期四", value: "8"},
          {week: "星期五", value: "16"},
          {week: "星期六", value: "32"},
          {week: "星期日", value: "64"},
        ],
        weekdays: [
          {week: "星期一", value: "0"},
          {week: "星期二", value: "1"},
          {week: "星期三", value: "2"},
          {week: "星期四", value: "3"},
          {week: "星期五", value: "4"},
          {week: "星期六", value: "5"},
          {week: "星期日", value: "6"},
        ],
        //集控定时
        OperationalControlForm: {
          time: {
            PeriodStart_1: '',
            PeriodStart_2: '',
            PeriodStart_3: '',
          },
          week: [],
          Passage: [],
        },
        ControlWeekCheckedAll: false,
        ControlPassageCheckedAll: false,
        ControlPassage: [
          {Passage: "通道一", value: "1"},
          {Passage: "通道二", value: "2"},
          {Passage: "通道三", value: "3"},
          {Passage: "通道四", value: "4"},
        ],
        // 单灯定时
        OperationalLampForm: {
          time: {
            PeriodStart_1: '',
            PeriodStart_2: '',
            PeriodStart_3: '',
            PeriodStart_4: '',
          },
          brightness: {
            brightness_1: "",
            brightness_2: "",
            brightness_3: "",
            brightness_4: "",
          },
          week: [],
        },
        LampWeekCheckedAll: false,
        // 单灯开关
        Open: false,
        Close: false,
        //多选
        isCheckedAll: false,
        control: [],//集控操作上传id缓存
        lamp: [],//单灯操作上传id缓存
        PassagewayData: [
          {name: '通道一', value: "0"},
          {name: '通道二', value: "1"},
          {name: '通道三', value: "2"},
          {name: '通道四', value: "3"},
        ],
        Passageway: '',//通道上传缓存
        //初始化分页
        totalPage: 1, // 统共页数，默认为1
        currentPage: 1, //当前页数 ，默认为1
        pageSize: 9, // 每页显示数量
        currentPageData: [] //当前页显示内容
      }
    },
    mounted() {

    },
    beforeDestroy() {
      clearTimeout(this.timer);
    },
    methods: {
      setTimeOut:function () {
        this.msg_show = !this.msg_show;
      },
      InitLeftMenu: function () {
        this.$emit('getMessage', '0', '1');
      },
      ControlNewData: function (id) {
        this.message = "暂无数据";
        this.msg_show = !this.msg_show;
        this.timer = setTimeout(this.setTimeOut, 2000);
      },
      LampNewData: function (id) {
        this.message = "暂无数据";
        this.msg_show = !this.msg_show;
        this.timer = setTimeout(this.setTimeOut, 2000);
      },
      getOnStatic:function(){
        fetch("/api/v1/statistics", {
          method: 'post',
          body: JSON.stringify({
            project_id:"17e3b71e-b460-498e-b0ef-657d20bd6549"
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            this.statistics = data.data;
          })
      },
      //集控器单选和全选
      ControlCheckedOne(id) {
        let idIndex = this.control.indexOf(id);
        if (idIndex >= 0) {
          // 如果已经包含了该id, 则去除(单选按钮由选中变为非选中状态)
          this.control.splice(idIndex, 1)
        } else {
          // 选中该checkbox
          this.control.push(id)
        }
        this.lamp = [];
        $('input[class="lamp"]').each(function () {
          $(this).prop("checked", false);
        });
      },
      ControlCheckedAll() {
        this.isCheckedAll = !this.isCheckedAll;
        if (this.isCheckedAll) {
          // 全选时
          this.control = [];
          this.currentPageData.forEach(function (currentPageData) {
            this.control.push(currentPageData.id)
          }, this)
          $('input[name="control"]').each(function () {
            $(this).prop("checked", true);
          });
        } else {
          this.control = [];
          $('input[name="control"]').each(function () {
            $(this).prop("checked", false);
          });
        }
        this.lamp = [];
        $('input[class="lamp"]').each(function () {
          $(this).prop("checked", false);
        });
      },
      //单灯全选和单选
      LampCheckedAll($this, id, num) {
        let click = $this.currentTarget.checked;
        let data = this.currentPageData[id].children;
        let name = num + 'lamp';
        if (click) {
          // 全选时
          data.forEach(function (data) {
            let idIndex = this.lamp.indexOf(data.lamppost);
            console.log(idIndex);
            if (idIndex < 0) {
              this.lamp.push(data.lamppost)
            }
          }, this);
          $('input[name="' + name + '"]').each(function () {
            $(this).prop("checked", true);
          });
        } else {
          data.forEach(function (data) {
            let idIndex = this.lamp.indexOf(data.lamppost);
            if (idIndex >= 0) {
              // 如果已经包含了该id, 则去除(单选按钮由选中变为非选中状态)
              this.lamp.splice(idIndex, 1)
            }
          }, this);
          $('input[name="' + name + '"]').each(function () {
            $(this).prop("checked", false);
          });
        }
        this.control = [];
        $('input[class="control"]').each(function () {
          $(this).prop("checked", false);
        });
        console.log(this.lamp)
      },
      LampCheckedOne(id) {
        let idIndex = this.lamp.indexOf(id);
        if (idIndex >= 0) {
          // 如果已经包含了该id, 则去除(单选按钮由选中变为非选中状态)
          this.lamp.splice(idIndex, 1)
        } else {
          // 选中该checkbox
          this.lamp.push(id)
        }

        this.control = [];
        $('input[class="control"]').each(function () {
          $(this).prop("checked", false);
        });
      },
      //手动控制
      ArtificialControl: function () {
        if (this.control.length > 0) {
          fetch("/api/v1/controller/mode/manual", {
            method: 'post',
            body: JSON.stringify({
              "lamppost_id": this.control,
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              if (data.code == "200") {
                this.message = "所选集控器设置手动控制成功";
                this.refresh = true;
                this.msg_show = !this.msg_show;
                this.timer = setTimeout(this.setTimeOut, 2000);
                this.control = [];
              } else {
                this.message = "手动控制设置异常，请重试";
                this.msg_show = !this.msg_show;
                this.timer = setTimeout(this.setTimeOut, 2000);
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
              this.timer = setTimeout(this.setTimeOut, 2000);
            });
        } else if (this.lamp.length > 0) {
          fetch("/api/v1/lamp/mode/manual", {
            method: 'post',
            body: JSON.stringify({
              lamppost_id: this.lamp,
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              if (data.code == "200") {
                this.message = "所选单灯设置手动控制成功";
                this.refresh = true;
                this.msg_show = !this.msg_show;
                this.timer = setTimeout(this.setTimeOut, 2000);
                this.lamp = [];
              } else {
                this.message = "手动控制设置异常，请重试";
                this.msg_show = !this.msg_show;
                this.timer = setTimeout(this.setTimeOut, 2000);
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
              this.timer = setTimeout(this.setTimeOut, 2000);
            });
        } else {
          this.message = "请选择集控器或单灯控制器";
          this.msg_show = !this.msg_show;
          this.timer = setTimeout(this.setTimeOut, 2000);
        }
      },
      //自动控制
      AutomateControl: function () {
        if (this.control.length > 0) {
          fetch("/api/v1/controller/mode/auto", {
            method: 'post',
            body: JSON.stringify({
              "lamppost_id": this.control,
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              if (data.code == "200") {
                this.message = "所选集控器设置自动控制成功";
                this.refresh = true;
                this.msg_show = !this.msg_show;
                this.timer = setTimeout(this.setTimeOut, 2000);
                this.control = [];
              } else {
                this.message = "自动控制设置异常，请重试";
                this.msg_show = !this.msg_show;
                this.timer = setTimeout(this.setTimeOut, 2000);
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
              this.timer = setTimeout(this.setTimeOut, 2000);
            });
        } else if (this.lamp.length > 0) {
          fetch("/api/v1/lamp/mode/auto", {
            method: 'post',
            body: JSON.stringify({
              lamppost_id: this.lamp,
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              if (data.code == "200") {
                this.message = "所选集控器设置自动控制成功";
                this.refresh = true;
                this.msg_show = !this.msg_show;
                this.timer = setTimeout(this.setTimeOut, 2000);
                this.lamp = [];
              } else {
                this.message = "自动控制设置异常，请重试";
                this.msg_show = !this.msg_show;
                this.timer = setTimeout(this.setTimeOut, 2000);
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
              this.timer = setTimeout(this.setTimeOut, 2000);
            });
        } else {
          this.message = "请选择集控器或单灯控制器";
          this.msg_show = !this.msg_show;
          this.timer = setTimeout(this.setTimeOut, 2000);
        }
      },
      //开启通道
      OpenPassageway: function () {
        if (this.control.length > 0) {
          fetch("/api/v1/controller/open", {
            method: 'post',
            body: JSON.stringify({
              controller_id: this.control,
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              if (data.code == "200") {
                this.message = "所选集控器通道已开启";
                this.refresh = true;
                this.msg_show = !this.msg_show;
                this.timer = setTimeout(this.setTimeOut, 2000);
              } else {
                this.message = "开启异常，请重试";
                this.msg_show = !this.msg_show;
                this.timer = setTimeout(this.setTimeOut, 2000);
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
              this.timer = setTimeout(this.setTimeOut, 2000);
            });
        } else {
          this.message = "请选择集控器";
          this.msg_show = !this.msg_show;
          this.timer = setTimeout(this.setTimeOut, 2000);
        }
      },
      //关闭通道
      ClosePassageway: function () {
        if (this.control.length > 0) {
          fetch("/api/v1/controller/close", {
            method: 'post',
            body: JSON.stringify({
              controller_id: this.control,
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              if (data.code == "200") {
                this.message = "所选集控器通道已关闭";
                this.refresh = true;
                this.msg_show = !this.msg_show;
                this.timer = setTimeout(this.setTimeOut, 2000);
              } else {
                this.message = "关闭异常，请重试";
                this.msg_show = !this.msg_show;
                this.timer = setTimeout(this.setTimeOut, 2000);
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
              this.timer = setTimeout(this.setTimeOut, 2000);
            });
        } else {
          this.message = "请选择集控器";
          this.msg_show = !this.msg_show;
          this.timer = setTimeout(this.setTimeOut, 2000);
        }
      },
      //校准时间
      CorrectionTime: function () {
        if (this.control.length > 0) {
          fetch("/api/v1/controller/time/update", {
            method: 'post',
            body: JSON.stringify({
              controller_id: this.control,
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              if (data.code == "200") {
                this.message = "所选集控器时间已校准";
                this.refresh = true;
                this.msg_show = !this.msg_show;
                this.timer = setTimeout(this.setTimeOut, 2000);
              } else {
                this.message = "开启异常，请重试";
                this.msg_show = !this.msg_show;
                this.timer = setTimeout(this.setTimeOut, 2000);
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
              this.timer = setTimeout(this.setTimeOut, 2000);
            });
        } else {
          this.message = "请选择集控器";
          this.msg_show = !this.msg_show;
          this.timer = setTimeout(this.setTimeOut, 2000);
        }
      },
      //集控控制时间
      OperationalControl: function () {
        if (this.control.length > 0) {
          this.OperationalControlBox = !this.OperationalControlBox
        } else {
          this.message = "请选择集控器";
          this.msg_show = !this.msg_show;
          this.timer = setTimeout(this.setTimeOut, 2000);
        }
      },
      //集控时间全选
      ControlWeekAll: function () {
        this.ControlWeekCheckedAll = !this.ControlWeekCheckedAll;
        if (this.ControlWeekCheckedAll) {
          // 全选时
          this.OperationalControlForm.week = []
          this.Week.forEach(function (Week) {
            this.OperationalControlForm.week.push(Week.value)
          }, this)
        } else {
          this.OperationalControlForm.week = []
        }
      },
      //集控时间单选
      ControlWeekOne: function (id) {
        let idIndex = this.OperationalControlForm.week.indexOf(id)
        if (idIndex >= 0) {
          // 如果已经包含了该id, 则去除(单选按钮由选中变为非选中状态)
          this.OperationalControlForm.week.splice(idIndex, 1)
        } else {
          // 选中该checkbox
          this.OperationalControlForm.week.push(id)
        }
        // if (this.OperationalControlForm.week.length<6){
        //   $('#ControlWeekAll').prop("checked", false);
        // } else {
        //   $('#ControlWeekAll').prop("checked", true);
        // }
      },
      //集控控制提交
      OperationalControlSbt: function () {
        if (this.OperationalControlForm.Passage.length < 1 || this.OperationalControlForm.time.length < 2 || this.OperationalControlForm.week.length < 1) {
          this.message = "请输入完整信息";
          this.msg_show = !this.msg_show;
          this.timer = setTimeout(this.setTimeOut, 2000);
        } else {
          fetch("/api/v1/controller/task/set", {
            method: 'post',
            body: JSON.stringify({
              controller_id: this.control,
              firstStartTime: this.OperationalControlForm.time.PeriodStart_1[0].substring(0, 5),
              firstEndTime: this.OperationalControlForm.time.PeriodStart_1[1].substring(0, 5),
              secondStartTime: this.OperationalControlForm.time.PeriodStart_2[0].substring(0, 5),
              secondEndTime: this.OperationalControlForm.time.PeriodStart_2[1].substring(0, 5),
              thirdStartTime: this.OperationalControlForm.time.PeriodStart_3[0].substring(0, 5),
              thirdEndTime: this.OperationalControlForm.time.PeriodStart_3[1].substring(0, 5),
              checkedWeekdaysString: this.OperationalControlForm.week.join(","),
              checkedWaysString: this.OperationalControlForm.Passage.join(",")
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              if (data.code == "200") {
                this.message = "所选集控器设置控制时间成功";
                this.refresh = true;
                this.msg_show = !this.msg_show;
                this.timer = setTimeout(this.setTimeOut, 2000);
              } else {
                this.message = "设置异常，请重试";
                this.msg_show = !this.msg_show;
                this.timer = setTimeout(this.setTimeOut, 2000);
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
              this.timer = setTimeout(this.setTimeOut, 2000);
              throw  error
            });
        }

      },
      //集控通道全选
      ControlPassageAll: function () {
        this.ControlPassageCheckedAll = !this.ControlPassageCheckedAll;
        if (this.ControlPassageCheckedAll) {
          // 全选时
          this.OperationalControlForm.Passage = [];
          this.ControlPassage.forEach(function (ControlPassage) {
            this.OperationalControlForm.Passage.push(ControlPassage.value)
          }, this)
        } else {
          this.OperationalControlForm.Passage = []
        }
      },
      //集控通道单选
      ControlPassageOne: function (id) {
        let idIndex = this.OperationalControlForm.Passage.indexOf(id)
        if (idIndex >= 0) {
          // 如果已经包含了该id, 则去除(单选按钮由选中变为非选中状态)
          this.OperationalControlForm.Passage.splice(idIndex, 1)
        } else {
          // 选中该checkbox
          this.OperationalControlForm.Passage.push(id)
        }
      },
      //单灯控制时间
      OperationalLamp: function () {
        if (this.lamp.length > 0) {
          this.OperationalLampBox = !this.OperationalLampBox
        } else {
          this.message = "请选择单灯";
          this.msg_show = !this.msg_show;
          this.timer = setTimeout(this.setTimeOut, 2000);
        }
      },
      //单灯控制提交
      OperationalLampSbt: function () {
        console.log(this.OperationalLampForm);
        if(this.lamp.mode=='1'){
          alert("当前手动模式，无法设置单灯控制时间！");
        }else {
          if (this.OperationalLampForm.time.length < 2 || this.OperationalLampForm.brightness.length < 2 || this.OperationalLampForm.week.length < 1) {
            this.message = "请输入完整信息";
            this.msg_show = !this.msg_show;
            this.timer = setTimeout(this.setTimeOut, 2000);
          } else {
            fetch("/api/v1/lamp/task/set", {
              method: 'post',
              body: JSON.stringify({
                "lamppost_id": this.lamp,
                "tasks":[
                  {
                    start_time:this.OperationalLampForm.time.PeriodStart_1[0].substring(0, 5),
                    end_time:this.OperationalLampForm.time.PeriodStart_1[1].substring(0, 5),
                    brightness:this.OperationalLampForm.brightness.brightness_1,
                  },{
                    start_time:this.OperationalLampForm.time.PeriodStart_2[0].substring(0, 5),
                    end_time:this.OperationalLampForm.time.PeriodStart_2[1].substring(0, 5),
                    brightness:this.OperationalLampForm.brightness.brightness_2,
                  },{
                    start_time:this.OperationalLampForm.time.PeriodStart_3[0].substring(0, 5),
                    end_time:this.OperationalLampForm.time.PeriodStart_3[1].substring(0, 5),
                    brightness:this.OperationalLampForm.brightness.brightness_3,
                  }
                  ,{
                    start_time:this.OperationalLampForm.time.PeriodStart_4[0].substring(0, 5),
                    end_time:this.OperationalLampForm.time.PeriodStart_4[1].substring(0, 5),
                    brightness:this.OperationalLampForm.brightness.brightness_4,
                  }
                ],
                "weekdays": this.OperationalLampForm.week.join(",")
              })
            })
              .then(result => {
                return result.json();//解析流
              })
              .then(data => {
                if (data.code == "200") {
                  this.message = "所选单灯设置控制时间成功";
                  this.refresh = true;
                  this.msg_show = !this.msg_show;
                  this.timer = setTimeout(this.setTimeOut, 2000);
                } else {
                  this.message = "设置异常，请重试";
                  this.msg_show = !this.msg_show;
                  this.timer = setTimeout(this.setTimeOut, 2000);
                }
              })
              .catch((error) => {
                this.message = "网络异常，请重试";
                this.msg_show = !this.msg_show;
                this.timer = setTimeout(this.setTimeOut, 2000);
                throw  error
              });
          }
        }

      },
      //单灯时间全选
      LampWeekAll: function () {
        this.LampWeekCheckedAll = !this.LampWeekCheckedAll;
        if (this.LampWeekCheckedAll) {
          // 全选时
          this.OperationalLampForm.week = []
          this.weekdays.forEach(function (weekdays) {
            this.OperationalLampForm.week.push(weekdays.value)
          }, this)
        } else {
          this.OperationalLampForm.week = []
        }
      },
      //单灯时间单选
      LampWeekOne: function (id) {
        let idIndex = this.OperationalLampForm.week.indexOf(id)
        if (idIndex >= 0) {
          // 如果已经包含了该id, 则去除(单选按钮由选中变为非选中状态)
          this.OperationalLampForm.week.splice(idIndex, 1)
        } else {
          // 选中该checkbox
          this.OperationalLampForm.week.push(id)
        }
      },
      //调节亮度
      AdjustBrightness: function () {
        if (this.lamp.length > 0) {
          this.brightness = !this.brightness
        } else {
          this.message = "请选择单灯控制器";
          this.msg_show = !this.msg_show;
          this.timer = setTimeout(this.setTimeOut, 2000);
        }
      },
      brightness_sbt: function () {
        fetch("/api/v1/lamp/brightness", {
          method: 'post',
          body: JSON.stringify({
            "lamppost_id":this.lamp,
            brightness: this.brightnessData.toString()

          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            console.log(data)
            if (data.code == "200") {
              this.message = "所选单灯调节亮度成功";
              this.brightness = !this.brightness;
              this.refresh = true;
              this.msg_show = !this.msg_show;
              this.timer = setTimeout(this.setTimeOut, 2000);
            } else {
              this.message = "操作异常，请重试";
              this.brightness = !this.brightness;
              this.msg_show = !this.msg_show;
              this.timer = setTimeout(this.setTimeOut, 2000);
            }
          })
          .catch((error) => {
            this.message = "网络连接异常，请重试";
            this.brightness = !this.brightness;
            this.msg_show = !this.msg_show;
            this.timer = setTimeout(this.setTimeOut, 2000);
            throw error;
          });
      },
      brightness_cancel: function () {
        this.brightnessData = 1;
        this.brightness = !this.brightness;
      },
      //开灯
      OpenLamp: function () {
        if (this.lamp.length > 0) {
          this.Open = !this.Open
        } else {
          this.message = "请选择单灯控制器";
          this.msg_show = !this.msg_show;
          this.timer = setTimeout(this.setTimeOut, 2000);
        }
      },
      OpenLamp_sbt: function () {
        fetch("/api/v1/lamp/open", {
          method: 'post',
          body: JSON.stringify({
            "lamppost_id":this.lamp,
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            if (data.code == "200") {
              this.message = "所选单灯开灯成功";
              this.Open = !this.Open;
              this.refresh = true;
              this.msg_show = !this.msg_show;
              this.timer = setTimeout(this.setTimeOut, 2000);
            } else {
              this.message = "操作异常，请重试";
              this.Open = !this.Open;
              this.msg_show = !this.msg_show;
              this.timer = setTimeout(this.setTimeOut, 2000);
            }
          })
          .catch((error) => {
            this.message = "网络连接异常，请重试";
            this.Open = !this.Open;
            this.msg_show = !this.msg_show;
            this.timer = setTimeout(this.setTimeOut, 2000);
            throw error;
          });

      },
      OpenLamp_cancel: function () {
        this.Open = !this.Open
      },
      //关灯
      CloseLamp: function () {
        if (this.lamp.length > 0) {
          this.Close = !this.Close
        } else {
          this.message = "请选择单灯控制器";
          this.msg_show = !this.msg_show;
          this.timer = setTimeout(this.setTimeOut, 2000);
        }
      },
      CloseLamp_sbt: function () {
        fetch("/api/v1/lamp/close", {
          method: 'post',
          body: JSON.stringify({
            "lamppost_id":this.lamp,
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            if (data.code == "200") {
              this.message = "所选单灯关灯成功";
              this.Close = !this.Close;
              this.refresh = true;
              this.msg_show = !this.msg_show;
              this.timer = setTimeout(this.setTimeOut, 2000);
            } else {
              this.message = "操作异常，请重试";
              this.Close = !this.Close;
              this.msg_show = !this.msg_show;
              this.timer = setTimeout(this.setTimeOut, 2000);
            }
          })
          .catch((error) => {
            this.message = "网络连接异常，请重试";
            this.Close = !this.Close;
            this.msg_show = !this.msg_show;
            this.timer = setTimeout(this.setTimeOut, 2000);
            throw error;
          });
      },
      CloseLamp_cancel: function () {
        this.Close = !this.Close
      },
      //刷新页面
      leave: function () {
        if (this.refresh) {
          this.$router.push({path: '/monitoring/null'})
        }
      },

      //获取列表
      getControllerAllList:function () {
        fetch("/api/v1/controller/list", {
          method: 'post',
          body: JSON.stringify({
            "project_id": "17e3b71e-b460-498e-b0ef-657d20bd6549",
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            this.currentPageData = data.data;
          })
          .catch((error) => {
            console.log(error);
          });
      }


    },
    created() {
      this.InitLeftMenu();
      this.getOnStatic();
      this.Passageway = this.PassagewayData[0].value;
      this.getControllerAllList();
    },
    updated() {
      $(".toggle").children("span").click(function () {
        $(this).toggleClass("show");
        $(this).parent().parent().siblings('.table-child').toggleClass('tablehide');
      });
    },
  }

</script>

<style scoped>
  .demonstration {
    color: #FFFFFF;
    font-size: 14px;
  }

  .tablehide {
    display: none !important;
  }

  .Period > div {
    margin-bottom: 10px;
  }

  .TodayStatistics {
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .search {
    width: 100%;
    height: 100px;
    padding: 20px 0;
  }

  .search_box {
    width: 65%;
    height: 100%;
    margin-right: 10px;
    background: #16518d;
    border-radius: 6px;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .search_options_box {
    width: calc(30% - 20px);
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;

    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #a2b9d1;
    color: #a2b9d1;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 48px;
    right: 20px;
    cursor: pointer;
  }

  .search_btn_box {
    width: 80px;
    padding: 10px;
  }

  .clearborder {
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search_btn {
    width: 100%;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
  }

  .icon_btn span {
    margin-right: 8px;
  }

  .green {
    background: #21b868;
    color: #FFFFFF;
  }

  .green:active {
    background: #15a95a;
  }

  .yellow {
    background: #f2ae4d;
    color: #FFFFFF;
  }

  .yellow:active {
    background: #dc8509;
  }

  .blue {
    background: #7aafeb;
    color: #FFFFFF;
  }

  .blue:active {
    background: #3574ba;
  }

  .search_information {
    width: calc(35% - 10px);
    float: left;
    height: 100%;
    background: #16518d;
    border-radius: 6px;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .search_information_content {
    padding: 10px;
    width: 33%;
    height: 100%;
    float: left;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  .search_information_content > div:nth-child(1) {
    min-width: 36px;
    min-height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    margin-right: 10px;
  }

  .search_information_content > div:nth-child(1) > span {
    font-size: 20px;
  }

  .search_information_content > div:nth-child(2) {
    width: auto;
    height: 50px;
  }

  .search_information_content > div:nth-child(2) > p {
    line-height: 20px;
    height: 20px;
    font-size: 14px;
    text-align: left;
    color: #FFFFFF;
    margin-bottom: 0;
  }

  .search_information_content > div:nth-child(2) > span {
    font-family: '$number';
    font-size: 30px;
    height: 30px;
    line-height: 30px;
    text-align: left;
  }

  .operation_btn {
    width: auto;
    padding: 0 20px;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
    margin: 0 5px;
  }

  .table_content {
    width: 100%;
    height: calc(100% - 380px);
    overflow-y: auto;
    margin: 20px 0;
  }

  .table_content > table {
    width: 100%;
    background-color: #16518d;
  }

  .table_content > table tr th {
    background-color: #0e345b;
  }

  .table_content > table tr td {
    /*background-color: #16518d;*/
  }

  .table_content > table tr td p {
    margin-bottom: 0;
    height: 20px;
    line-height: 20px;
  }

  .table_content input {
    width: 16px;
    height: 16px;
    margin: 0 10px;

  }

  .table_content > table tr:nth-child(2n) {
    background-color: #11406f;
  }

  .table_content > table tr {
    /*border-bottom: 1px solid #225892;*/
    height: 62px;
    width: 100%;
  }

  .table_content > table tr td, .table_content > table tr th {
    text-align: center;
    color: #FFFFFF;
  }

  .operation {
    height: 120px;
    width: 100%;
    border: 1px solid #105ba8;
    border-radius: 6px;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .operation div {
    height: 60px;
    display: flex;
    align-items: center;
    position: relative;
  }

  .operation > div > img {
    position: absolute;
    left: 180px;
    top: 28px;
  }

  .operation span {
    color: #FFFFFF;
    margin-left: 5px;
  }

  .operation select {
    width: 120px;
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #a2b9d1;
    color: #a2b9d1;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .table_paging {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid #105ba8;
    border-radius: 6px;
  }

  .table_paging > p {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: right;
    margin-bottom: 0;
    color: #c1c2c6;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .table_paging > p > button {
    margin: 0 8px;
    width: 10px;
    height: 16px;
    border: none;
    outline: none;
  }

  .table_btn {
    color: #95bee5;
    background: transparent;
    border: 1px solid #95bee5;
    outline: transparent;
    padding: 5px 10px;
    border-radius: 6px;
  }

  .table-child-title {
    height: 50px !important;
  }

  .table-child-title > th {
    background: #a3d0fc !important;
  }

  .table-child > th {
    background: #a3d0fc;
    text-align: center;
    color: #333333 !important;
  }

  .table-child > td {
    background: #cfe6fd !important;
    border-bottom: 1px solid #FFFFFF;
    color: #000000 !important;
    text-align: center;
  }

  .show {
    background: url("/static/img/lamp/tableclose.png") no-repeat center center !important;
  }

  .table-child input[type='checkbox'] {
    width: 16px;
    height: 16px;
    -webkit-appearance: none;
    border-radius: 2px;
    background: url(/static/img/nocheckbox2.png) no-repeat center;
    background-size: 100% 100%;
    outline: none;
  }

  .table-child input[type=checkbox]:checked {
    background: url(/static/img/checkbox2.png) no-repeat center center;
    background-size: 100% 100%;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }

  .scale {
    width: 100%;
    display: flex;
    position: relative;
    height: 20px;
  }

  .scale > span {
    position: absolute;
    color: #FFFFFF;
    height: 20px;
    width: auto;
  }

  .week > span, .Passage > span {
    color: #FFFFFF;
    float: left;
  }

  .week label, .Passage label {
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    float: left;
    margin-left: 10px;
  }

  .week label:nth-child(8) {
    margin-left: 90px;
  }
</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/1_lamp/equipment_management.vue